import { ApiError } from '@/api/client';

// Records indexés par les littéraux exacts de l'enum (et non `number`) : la lecture reste
// typée sans `| undefined`, `noUncheckedIndexedAccess` étant activé sur ce projet.
export const formatLabels: Record<0 | 1 | 2 | 3, string> = {
  0: 'Paysage 16:9',
  1: 'Portrait 9:16',
  2: 'Carré 1:1',
  3: 'Ultra-large 21:9',
};

/** Classes de ratio pour afficher vignettes et aperçus sans les déformer. */
export const formatAspectClasses: Record<0 | 1 | 2 | 3, string> = {
  0: 'aspect-video',
  1: 'aspect-[9/16]',
  2: 'aspect-square',
  3: 'aspect-[21/9]',
};

export type TemplateStatusValue = 0 | 1 | 2;

export const statusLabels: Record<TemplateStatusValue, string> = {
  0: 'Brouillon',
  1: 'Publié',
  2: 'Archivé',
};

export const statusTones: Record<TemplateStatusValue, 'neutral' | 'success' | 'warning'> = {
  0: 'neutral',
  1: 'success',
  2: 'warning',
};

export const fieldKindLabels: Record<0 | 1 | 2 | 3 | 4 | 5, string> = {
  0: 'Texte',
  1: 'Texte long',
  2: 'Prix',
  3: 'Image',
  4: 'Vidéo',
  5: 'Couleur',
};

/**
 * Libellés des actions du journal d'audit, indexés sur les noms renvoyés par l'API
 * (`TemplateAuditAction`). Une action inconnue — ajoutée côté serveur avant que cet écran ne
 * soit redéployé — retombe sur son nom brut plutôt que de n'afficher rien du tout.
 */
export const auditActionLabels: Record<string, string> = {
  Created: 'Créé',
  Updated: 'Modifié',
  Published: 'Publié',
  Archived: 'Archivé',
  PremiumChanged: 'Accès modifié',
  FieldAdded: 'Champ ajouté',
  FieldVisibilityChanged: 'Champ figé ou réactivé',
  FileReplaced: 'Fichier redéposé',
};

export const auditDateFormatter = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Message d'erreur à afficher pour une mutation en échec. Le message d'une `ApiError` est
 * rédigé pour l'utilisateur par l'API ; une autre erreur (réseau, dépôt sur le stockage)
 * garde le sien, déjà en français dans les hooks.
 */
export function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError || error instanceof Error) {
    return error.message || fallback;
  }

  return fallback;
}
